import { IconOption } from '../../components/Icon'

export const getSpaceIconName = (spaceType: string): IconOption => {
    switch (spaceType) {
    case 'presentation':
        return 'presentation'
    case 'map':
        return 'map'
    case 'meeting':
        return 'meeting'
    case 'cinema':
        return 'cinema'
    case 'networking':
        return 'networking'
    case 'posters':
        return 'poster'
    case 'jobs':
        return 'job'
    default:
        return 'view'
    }
}
